"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function MobileMenuClose({ toggleId = "nav-toggle" }: { toggleId?: string }) {
  const pathname = usePathname();

  useEffect(() => {
    const input = document.getElementById(toggleId) as HTMLInputElement | null;
    if (input) input.checked = false;
  }, [pathname, toggleId]);

  return null;
}


